module.exports = __webpack_public_path__ + "static/Titans-of-Empowerment-fade416123dd5be906ed5235a2ab5d98.jpg";